<template>
    <div>

        <!-- <section class="inner_banner">

        </section> -->

        <section class="how_it_works">
            <div class="container">
                <h2>How It Works</h2>
                <article class="row">
                    <aside class="col-md-4">
                        <div class="how_it_works_inner">
                            <div class="how_it_works_img">
                                <img src="../assets/images/step1.png" alt="">
                            </div>
                            <div class="how_it_works_text">
                                <h4>Step 1</h4>
                                <p>Select the coins that you want to switch with us and then select the quantity that you want to switch. When you’re ready, click
                                    <a href="#">Exchange Now </a>. </p>
                            </div>
                        </div>
                    </aside>
                    <aside class="col-md-4">
                        <div class="how_it_works_inner">
                            <div class="how_it_works_img">
                                <img src="../assets/images/step2.png" alt="">
                            </div>
                            <div class="how_it_works_text">
                                <h4>Step 2</h4>
                                <p>Check all of the information that you put into the form to see if it is correct for your Stable Switch experience . Then, enter your ERC20 Token address to receive your funds. </p>
                            </div>
                        </div>
                    </aside>
                    <aside class="col-md-4">
                        <div class="how_it_works_inner">
                            <div class="how_it_works_img">
                                <img src="../assets/images/step3.png" alt="">
                            </div>
                            <div class="how_it_works_text">
                                <h4>Step 3</h4>
                                <p>You can now sit back and watch the progress of your Stable Switch! You can also view your progress on Etherscan. </p>
                            </div>
                        </div>
                    </aside>
                </article>

            </div>
        </section>

        <section class="video">
            <div class="container">
                <article class="row justify-content-center">
                    <aside class="col-md-8 ">
                        <div class="video_inner">
                            <iframe width="100%" height="400" src="https://www.youtube.com/embed/yAoLSRbwxL8" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                        </div>
                    </aside>
                </article>
            </div>
        </section>
    </div>
</template>

<script>
export default {
    name: 'HowItWorks'
}
</script>

<style scoped>

</style>
